import api from "@/utils/axios";

const ORDER_ITEM_API_URL = `/orders`;

export default {
  namespaced: true,
  state: {
    loading: false,
    error: null,
  },
  mutations: {
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
  },
  actions: {
    async createOrderItem({ commit, dispatch }, { order_id, payload }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const res = await api.post(
          `${ORDER_ITEM_API_URL}/${order_id}/items/`,
          payload,
          {
            successNotify: true,
            errorNotify: true,
          }
        );
        commit("order/SET_ORDER", res.data, { root: true });

        const productId = payload.product_id || res.product_id;
        if (productId) {
          await dispatch("product/refreshSingleProduct", productId, {
            root: true,
          });
        }

        return res.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || "Failed to create order item"
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async updateOrderItem({ commit, dispatch, rootState }, { id, payload }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const orderItems = rootState.order.order?.order_items || [];
        const orderItem = orderItems.find((item) => item.id === id);

        const res = await api.patch(
          `${ORDER_ITEM_API_URL}/items/${id}/`,
          payload,
          {
            successNotify: true,
            errorNotify: true,
          }
        );
        commit("order/SET_ORDER", res.data.order, { root: true });

        if (orderItem?.product_id) {
          await dispatch("product/refreshSingleProduct", orderItem.product_id, {
            root: true,
          });
        }

        return res.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || "Failed to update order item"
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async deleteOrderItem({ commit, dispatch, rootState }, id) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const orderItems = rootState.order.order?.order_items || [];
        const itemToDelete = orderItems.find((item) => item.id === id);
        const productId = itemToDelete?.product_id;

        const res = await api.delete(`${ORDER_ITEM_API_URL}/items/${id}/`, {
          successNotify: true,
          errorNotify: true,
        });
        commit("order/SET_ORDER", res.data.order, { root: true });

        if (productId) {
          await dispatch("product/refreshSingleProduct", productId, {
            root: true,
          });
        }

        return res.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || "Failed to delete order item"
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
  getters: {
    orderItemLoading: (state) => state.loading,
    orderItemError: (state) => state.error,
  },
};
